import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  isSameTransactionOption,
  WithdrawalTransactionOption,
} from '../../withdrawal-bank.config';

@Component({
  selector: 'app-withdrawal-application-selector',
  templateUrl: './withdrawal-application-selector.component.html',
})
export class WithdrawalApplicationSelectorComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() options: WithdrawalTransactionOption[] = [];
  @Input() variant: 'select' | 'text' = 'text';

  compareTransactionOptions(
    a: WithdrawalTransactionOption | null,
    b: WithdrawalTransactionOption | null,
  ): boolean {
    if (!a || !b) {
      return a === b;
    }

    return isSameTransactionOption(a, b);
  }
}
